module.exports = __webpack_public_path__ + "static/media/asko_logo.22112cf5.png";